import { Box } from "@mui/material";
import React, { useRef } from "react";

import { Typography, PageContainer, InnerContentContainer, GreyContainer, PandaVideo } from "../../components";


import { SejaPlusContainer, VideoWrapper, CTAButton } from "./SejaPlusStyled";

export interface Props {
	background?: string;
	children?: React.ReactNode;
}

const SejaPlus: React.FC<Props> = ({ children, background = "#FFF", ...props }) => {
	const playerRef = useRef<HTMLVideoElement>(null)
	return (
		<PageContainer centerTitle={true} showBreadcrumb={false} pageTitle='Torne-se Aluno PLUS e tenha acesso ilimitado aos seus cursos, para sempre!' showUserAvatar={false} showSearch={false}>
			<GreyContainer>
				<InnerContentContainer>
					<SejaPlusContainer background={background} {...props}>
						<Box display='flex' justifyContent='space-between' flexWrap='wrap'>
							<div className='videoColumn'>
								<VideoWrapper>
									<iframe
										src='https://www.youtube.com/embed/souxZ3nufMU?autoplay=0'
										title='YouTube video player'
										// @ts-ignore
										frameborder='0'
										allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
										allowfullscreen></iframe>
								</VideoWrapper>

								<Typography variant='text' margin='20px 0' size='1.125rem' fontWeight='bold'>
									Clique no botão abaixo e ative agora sua assinatura PLUS com acesso completo e permanente:
								</Typography>
								<CTAButton href='https://pequen.in/W1RC' target='_blank'>
									QUERO SER ALUNO PLUS POR R$9 AGORA MESMO*
								</CTAButton>
								<Typography variant='text' margin='0 0 20px' size='0.85rem'>
									* Após 30 dias, sua assinatura continua por R$49,90/mês.<br />* Cancelamento fácil e sem burocracia.
								</Typography>
							</div>
							<div className='textColumn'>
								<Typography variant='text' margin='0 0 20px' size='1rem'>
									📌 Enquanto sua assinatura CIA Autismo PLUS estiver ativa, <b>você mantém acesso vitalício aos cursos que já adquiriu</b>, mesmo que o prazo normal de acesso tenha acabado.
								</Typography>
								<Typography variant='text' margin='0 0 20px' size='1.25rem' fontWeight="bold">
									Isso mesmo: seus cursos não vão mais expirar.
								</Typography>

								<Typography variant='text' margin='0 0 20px' size='1rem'>
									Você estudou, investiu tempo e dinheiro...<br />
									Não faz sentido perder tudo isso depois de alguns meses, certo?<br /><br />
									Com o <b>CIA Autismo PLUS</b>, você protege seu conhecimento e ainda desbloqueia uma verdadeira biblioteca sobre o autismo.
								</Typography>
								<Typography variant='text' margin='0 0 20px' size='1.5rem' fontWeight="bold">
									O que você leva como Aluno PLUS:
								</Typography>
								<Typography variant='text' margin='0 0 20px' size='1rem'>
									🎓 Acesso imediato a <b>+10 cursos completos com certificado</b>, incluindo:</Typography>
									<ul>
										<li>Terapia Alimentar no Transtorno do Espectro Autista (TEA)</li>
										<li>ABLA-R: Avaliando Habilidades Para a Aprendizagem</li>
										<li>Introdução à ABA</li>
										<li>E muitos outros conteúdos práticos, objetivos e atualizados</li>
									</ul>
								<Typography variant='text' margin='0 0 20px' size='1rem'>
									📚 Mais de 180 artigos exclusivos, com novos liberados toda semana<br />
									🧰 Mais de 80 ferramentas aplicáveis no dia a dia, para baixar e usar<br />
									🎥 Séries, documentários, entrevistas e aulas exclusivas<br />
									🧠 Acesso ao SociAutism, nosso software exclusivo para aplicação de Terapia ABA<br />
									👥 Aulas ao vivo e mais novidades<br />
									✅ E claro: acesso permanente a todos os cursos comprados, enquanto sua assinatura estiver ativa
								</Typography>

								<Typography variant='text' margin='0 0 20px' size='1.5rem'>
									Comece agora por apenas R$9 no primeiro mês!
								</Typography>
								<Typography variant='text' margin='0 0 20px' size='1rem'>
									Depois, continue por apenas <b>R$49,90/mês</b> e cancele quando quiser. Simples, direto, sem pegadinha.
									<br /><br />
									Já somos mais de <b>1.800 Alunos PLUS</b> em todo o Brasil.
									Junte-se a quem está levando o aprendizado a sério, e protegendo o que já conquistou.
								</Typography>

								<div className='ctaHideDesk'>
									<Typography variant='text' margin='20px 0' size='1.125rem' fontWeight='bold'>
									Clique no botão abaixo e ative agora sua assinatura PLUS com acesso completo e permanente:
								</Typography>
									<CTAButton href='https://pequen.in/W1RC' target='_blank'>
										QUERO SER ALUNO PLUS POR R$9 AGORA MESMO*
									</CTAButton>
									<Typography variant='text' margin='0 0 20px' size='0.85rem'>
									* Após 30 dias, sua assinatura continua por R$49,90/mês.<br />* Cancelamento fácil e sem burocracia.
								</Typography>
								</div>
							</div>
						</Box>
					</SejaPlusContainer>
				</InnerContentContainer>
			</GreyContainer>
		</PageContainer>
	);
};

export { SejaPlus };
